import React from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "../../util/asyncComponent";

interface iProps {
  match: {
    url: string
  }
}

const MonthlyReport = ({ match }: iProps): JSX.Element => (
  <Switch>
    <Route
      exact
      path={`${match.url}/acct`}
      component={asyncComponent(() => import('../../components/MonthlyReport/MonthlyReportAccount'))}
    />
    <Route
      exact
      path={`${match.url}/hf`}
      component={asyncComponent(() => import('../../components/MonthlyReport/MonthlyReportHedgeFund'))}
    />
  </Switch>
);

export default MonthlyReport;
